import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== POMOCNICZE FUNKCJE ====

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomA1() {
  // a1 z przedziału -9..-2 ∪ 2..9 (bez -1, 0, 1)
  const candidates = [];
  for (let x = -9; x <= 9; x++) {
    if (Math.abs(x) >= 2 && Math.abs(x) <= 9) {
      candidates.push(x);
    }
  }
  const idx = Math.floor(Math.random() * candidates.length);
  return candidates[idx];
}

// ==== GENERATOR ====

export function generateTask() {
  const a1 = randomA1();

  // q całkowite 2..7, losowo dodatnie lub ujemne
  const baseQ = randomInt(2, 7);
  const sign = Math.random() < 0.5 ? 1 : -1;
  const q = sign * baseQ;

  // liczba wyrazów 3..6 (jak w innych zadaniach z sumą)
  const n = randomInt(3, 6);

  const sum =
    q === 1
      ? a1 * n
      : (a1 * (1 - Math.pow(q, n))) / (1 - q);

  return {
    type: "FindNFromSumGeoTask",
    data: { sum, a1, q, n }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { sum, a1, q } = data;

  return (
    <>
      <p>
        Suma pierwszych <InlineMath math="n" /> wyrazów ciągu geometrycznego
        wynosi <InlineMath math={`${sum}`} />.
      </p>
      <p>
        Pierwszy wyraz to <InlineMath math={`a_1 = ${a1}`} />, a iloraz{" "}
        <InlineMath math={`q = ${q}`} />.
      </p>
      <p>
        Oblicz <InlineMath math="n" /> — liczbę wyrazów sumy.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2">
      <InlineMath math={"n ="} />
      <FractionInput
        value={userAnswer}
        onChange={onChange}
        disabled={disabled}
        label="n"
      />
    </div>
  );
}

// ==== SPRAWDZANIE ====

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseInt(userAnswer.raw, 10);
  if (isNaN(given)) return false;

  return given === data.n;
}

// ==== POPRAWNA ODPOWIEDŹ ====

export function renderAnswer({ data }) {
  return <InlineMath math={`n = ${data.n}`} />;
}

// ==== WYJAŚNIENIE ====

export function renderExplanation({ data }) {
  const { sum, a1, q, n } = data;

  const qn = Math.pow(q, n);
  const denominator = 1 - q;
  const numerator = 1 - qn;
  const fracValue = numerator / denominator;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Korzystamy ze wzoru na sumę{" "}
        <InlineMath math={"S_n"} /> ciągu geometrycznego dla{" "}
        <InlineMath math={"q \\neq 1"} />:
      </p>
      <BlockMath math={"S_n = a_1 \\cdot \\frac{1 - q^n}{1 - q}"} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane do wzoru.
      </p>
      <BlockMath
        math={`${sum} = ${a1} \\cdot \\frac{1 - (${q})^n}{1 - (${q})}`}
      />

      <p>
        <strong>Krok 3:</strong> Sprawdzamy kolejne wartości{" "}
        <InlineMath math={"n"} />. Dla{" "}
        <InlineMath math={`n = ${n}`} /> mamy:
      </p>
      <BlockMath
        math={`S_{${n}} = ${a1} \\cdot \\frac{1 - (${q})^{${n}}}{1 - (${q})}`}
      />
      <BlockMath
        math={`S_{${n}} = ${a1} \\cdot \\frac{1 - ${qn}}{${denominator}}`}
      />
      <BlockMath
        math={`S_{${n}} = ${a1} \\cdot ${fracValue} = ${sum}`}
      />

      <p>
        Otrzymujemy zatem <InlineMath math={`n = ${n}`} />.
      </p>
    </div>
  );
}

// ==== PODGLĄD ODPOWIEDZI UŻYTKOWNIKA ====

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`n = ${userAnswer.raw}`} />;
}
